export const SET_USER_ID_EMAIL_MAP = "SET_USER_ID_EMAIL_MAP";
export const SET_PERMISSION = "SET_PERMISSION"
export const GET_PERMISSIONS = "GET_PERMISSIONS"
export const SET_ACTIVE_PERMISSION = "SET_ACTIVE_PERMISSION"
export const EDIT_PERMISSION = "EDIT_PERMISSION"
export const REMOVE_PERMISSION = "REMOVE_PERMISSION"


// WEBPACK FOOTER //
// ./src/components/admin/types.js